<template>
  <div class="elderly-care-container" data-aos="fade-up">
    <!-- 欢迎文案 -->
    <div class="welcome-section" data-aos="fade-down" data-aos-delay="200">
      <h1>欢迎关注养老资讯</h1>
      <p class="welcome-text">
        我们为您提供最新的养老政策、健康知识和生活建议，帮助您和您的家人更好地享受晚年生活。
      </p>
    </div>

    <!-- 养老资讯 -->
    <!-- <div class="news-section" data-aos="fade-up" data-aos-delay="300">
      <h2 class="section-title">最新养老资讯</h2>
      <div class="news-grid">
        <div class="news-card" data-aos="zoom-in" data-aos-delay="400">
          <h3>如何选择合适的养老院</h3>
          <p>
            选择合适的养老院是每个家庭的重要决定。本文将为您提供一些有用的建议，帮助您找到适合您家人的养老院。
          </p>
          <a href="#" class="read-more">阅读更多</a>
        </div>
        <div class="news-card" data-aos="zoom-in" data-aos-delay="500">
          <h3>老年人健康饮食指南</h3>
          <p>
            良好的饮食习惯对老年人的健康至关重要。了解如何通过饮食保持健康和活力。
          </p>
          <a href="#" class="read-more">阅读更多</a>
        </div>
        <div class="news-card" data-aos="zoom-in" data-aos-delay="600">
          <h3>如何预防老年人常见疾病</h3>
          <p>了解老年人常见疾病的预防措施，帮助您和您的家人保持健康。</p>
          <a href="#" class="read-more">阅读更多</a>
        </div>
      </div>
    </div> -->

    <!-- 关注微信公众号 -->
    <div class="wechat-section" data-aos="fade-up" data-aos-delay="700">
      <h2 class="section-title">关注我们的微信公众号</h2>
      <p class="wechat-text">
        获取更多养老资讯和健康建议，请扫描下方二维码关注我们的微信公众号。
      </p>
      <div class="qr-code-placeholder">
        <!-- 这里可以替换为实际的微信公众号二维码图片 -->
        <img
          src="https://upload.shanxinyy.com/homepage/gzh.jpg"
          alt="微信公众号二维码"
        />
        <p>扫描二维码关注我们</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ElderlyCare",
  mounted() {
    // 初始化AOS动画
    import("aos").then((AOS) => {
      AOS.init({
        duration: 600,
        once: true,
      });
    });
  },
};
</script>

<style scoped>
.elderly-care-container {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", Arial, sans-serif;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.welcome-section {
  text-align: center;
  padding: 60px 0;
}

.welcome-section h1 {
  font-size: 36px;
  margin-bottom: 15px;
  color: #333;
}

.welcome-text {
  font-size: 18px;
  color: #666;
  max-width: 800px;
  margin: 0 auto;
}

.section-title {
  text-align: center;
  font-size: 28px;
  margin-bottom: 40px;
  color: #333;
}

.news-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 30px;
  margin-bottom: 60px;
}

.news-card {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s, box-shadow 0.3s;
}

.news-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
}

.news-card h3 {
  font-size: 20px;
  margin-bottom: 15px;
  color: #333;
}

.news-card p {
  color: #666;
  font-size: 14px;
  margin-bottom: 15px;
}

.read-more {
  color: #f97d01;
  text-decoration: none;
  font-weight: bold;
}

.read-more:hover {
  text-decoration: underline;
}

.wechat-section {
  text-align: center;
  padding: 60px 0;
}

.wechat-text {
  font-size: 18px;
  color: #666;
  margin-bottom: 30px;
}

.qr-code-placeholder {
  margin: 0 auto;
  max-width: 200px;
  padding: 20px;
  background: #f5f5f5;
  border-radius: 8px;
}

.qr-code-placeholder img {
  width: 100%;
  max-width: 150px;
  height: auto;
}

@media (max-width: 768px) {
  .news-grid {
    grid-template-columns: 1fr;
  }

  .welcome-section h1 {
    font-size: 28px;
  }

  .welcome-text {
    font-size: 16px;
  }
}
</style>
